import { render, staticRenderFns } from "./aftersaledetail.vue?vue&type=template&id=05f22ec5&"
import script from "./aftersaledetail.vue?vue&type=script&lang=js&"
export * from "./aftersaledetail.vue?vue&type=script&lang=js&"
import style0 from "./aftersaledetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports